import { useState } from 'react';
import Sidebar from '@/components/feature/Sidebar';
import Footer from '@/components/feature/Footer';
import { useNavigate } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
  showTopBar?: boolean;
  topBarContent?: React.ReactNode;
}

export default function Layout({ children, showTopBar = false, topBarContent }: LayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-background-50">
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="flex-1 flex flex-col min-w-0">
        {showTopBar && (
          <div className="sticky top-0 z-40 px-4 md:px-6 py-3 flex items-center justify-between gap-3 bg-background-50/95 backdrop-blur-md border-b border-background-200/70 shadow-sm">
            <div className="flex items-center gap-3">
              <button
                onClick={() => setSidebarOpen(true)}
                className="lg:hidden btn-press w-10 h-10 flex items-center justify-center rounded-lg text-foreground-600 hover:bg-background-100 active:bg-background-200 transition-colors cursor-pointer"
              >
                <i className="ri-menu-line text-xl" />
              </button>
              <h1 className="font-heading text-base md:text-lg lg:text-xl font-bold text-foreground-950 whitespace-nowrap">
                BIOLA CAFE & RESTAURANT
              </h1>
            </div>
            {topBarContent}
          </div>
        )}

        <main className="flex-1 overflow-auto">
          {children}
          <Footer />
        </main>
      </div>
    </div>
  );
}